import * as React from 'react';

import { Skeleton } from '../../../../components/OfferValuation/components/Skeleton';
import { useStaticData } from '../../utils/useStaticData';

export const SkeletonContainer: React.FC = () => {
  const { title } = useStaticData();

  return <Skeleton>{title}</Skeleton>;
};

SkeletonContainer.displayName = 'SkeletonContainer';
